import { t, Trans } from "@lingui/macro"
import { Box, Dialog, DialogContent, DialogTitle, FormLabel, IconButton, Typography } from "@mui/material"
import { ResourcesDetailsButton, ResourcesDetailsLightButton } from "../resources/ResourcesDetailsCard/Button"
import { useFormikContext } from "formik"
import { FirstLoginFlowFormikProps } from "./index"
import { InfoBanner } from "./InfoBanner"
import { TextFieldWithFormik } from "../common-components/with-formik/TextFieldWithFormik"
import { searchForAccountByFlow } from "app/services/sfAuth/sfData/sfAccount"
import { getJoinRequestCountByFlow } from "app/services/sfAuth/sfData/sfJoinRequest"
import { useSnackbar } from "notistack"
import OrganizationLine from "./OrganizationLine"
import { FormBanner } from "../forms/components/custom/banner/FormBanner"
import { myI18n } from "translation/I18nConnectedProvider";
import { useState } from "react"
import CloseIcon from '@mui/icons-material/Close';
import { JobDialog } from "./JobDialog"
import { useHistory } from "react-router-dom"
import { useDispatch } from "react-redux"
import { setUserData } from "app/redux/actions/UserActions"
import { useSelector } from "react-redux"
import { RootStateOrAny } from "react-redux"

export const OrganizationConnectRequestSent = () => {

  const { enqueueSnackbar } = useSnackbar()

  const [displayJobDialog, setDisplayJobDialog] = useState(false)

  const dispatch = useDispatch()

  const user = useSelector((state: RootStateOrAny) => state.user)

  const { 
    values, handleChange, handleBlur, setFieldValue, validateForm 
  } = useFormikContext<FirstLoginFlowFormikProps>()

  const onClickGoToHomepage = () => {
    setFieldValue('affiliations', null)
    dispatch(setUserData({
      ...user,
      contact: {
        ...user.contact,
        whatAreYouLookingFor: values.goal
      }
    }))
  }
  
  return (
    <>
      <JobDialog display={displayJobDialog} setDisplay={setDisplayJobDialog}/>

      <FormLabel sx={{ textAlign: 'center', fontSize: '24px', lineHeight: '28px', mb: '54px', mt: '-32px' }}>
        <Trans>FIRST_LOGIN_FLOW_CONNECT_TO_ORGANIZATION_LABEL</Trans>
      </FormLabel>

      <FormLabel sx={{ mb: '14px'}}>
        <Trans>FIRST_LOGIN_FLOW_YOUR_REQUEST_HAS_BEEN_SENT_LABEL</Trans>
      </FormLabel>

      <Typography variant="body2" sx={{ fontSize: '15px', lineHeight: '25px' }}>
        <Trans>FIRST_LOGIN_FLOW_REQUEST_WAS_SENT_NOTE_TEXT</Trans>
      </Typography>

      <Typography variant="body2" sx={{ fontSize: '15px', lineHeight: '25px', mt: '14px' }}>
        <Trans>FIRST_LOGIN_FLOW_REQUEST_WAS_SENT_TO_TEXT</Trans>
      </Typography>

      <InfoBanner 
        sx={{ mt: '24px' }}
        description={<Trans>FIRST_LOGIN_FLOW_CONTACT_YOUR_ORGANIZATION_TEXT</Trans>}
      />

      <ResourcesDetailsButton
        text={<Trans>FIRST_LOGIN_FLOW_REQUEST_GO_TO_HOMEPAGE_BUTTON</Trans>}
        onClick={onClickGoToHomepage}
        sx={{ mt: '14px' }}
        href="/"
      />

    </>
  )
}
